import { Popover, VStack, HStack, Text, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { ICourse } from '@/shared/ICourse';
import { AWARD_STATUS } from '@/shared/constants';
import { LabelAwarded } from '@/app/course/LabelAwarded';

export const CheckboxFilterLabel = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const getLabel = (award: string) => {
    switch (award) {
      case AWARD_STATUS.AWARDED:
        return 'Awarded (good)';
      case AWARD_STATUS.AWARDED_EDITION:
        return 'Awarded edition (satisfactory)';
      case AWARD_STATUS.NOT_AWARDED:
        return 'Not awarded';
      case AWARD_STATUS.WAS_AWARDED:
        return 'Awarded to the previous run';
      case AWARD_STATUS.UNKNONWN:
        return 'Unknown';
      default:
        return 'Unknown';
    }
  }

  // Collect all existing labels from courses
  const labelCounts = new Map<string, number>();
  
  props.allCourses?.forEach(course => {
    const award = course.LabelAwarded || AWARD_STATUS.UNKNONWN;
    labelCounts.set(award, (labelCounts.get(award) || 0) + 1);
  });

  const options = Array.from(labelCounts.entries()).map(([award, count]) => ({
    label: getLabel(award),
    value: award || AWARD_STATUS.UNKNONWN,
    count,
    award: award === AWARD_STATUS.UNKNONWN ? undefined : award as AWARD_STATUS
  })).sort((a, b) => {
    // Define the desired award order (best to worst, then unknown)
    const awardOrder = [
      AWARD_STATUS.AWARDED,           // Best: Awarded (good)
      AWARD_STATUS.AWARDED_EDITION,   // Good: Awarded edition (satisfactory)
      AWARD_STATUS.WAS_AWARDED,       // Historical: Awarded to previous run
      AWARD_STATUS.NOT_AWARDED,       // Not awarded
      AWARD_STATUS.UNKNONWN           // Unknown/No label
    ];
    
    const indexA = awardOrder.indexOf(a.value as AWARD_STATUS);
    const indexB = awardOrder.indexOf(b.value as AWARD_STATUS);
    
    return indexA - indexB;
  });

  const handleSelectionChange = (selectedValues: string[]) => {
    props.onSetFilter(selectedValues.length > 0 ? selectedValues : undefined);
  };

  const hasSelection = (props.value?.length || 0) > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Label" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxGroup value={props.value || []} onChange={handleSelectionChange}>
            <VStack spacing="2" align="stretch">
              {options.map((option) => (
                <Checkbox key={option.value} value={option.value} colorScheme="brand">
                  <HStack spacing="2" align="center">
                    <LabelAwarded award={option.value as AWARD_STATUS} />
                    <Text fontSize="sm">{option.label}</Text>
                    <Text fontSize="sm" color="gray.500">
                      ({option.count})
                    </Text>
                  </HStack>
                </Checkbox>
              ))}
            </VStack>
          </CheckboxGroup>
        </FilterPopoverContent>
    </Popover>
  );
};
